import * as tslib_1 from "tslib";
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as utils from '@ivy/fts/utils';
let CourseCard = class CourseCard extends Vue {
    constructor() {
        super(...arguments);
        this.smsCode = null;
        this.geting = false;
        this.countdownTimer = '重新获取 60s';
        this.canSend = false;
    }
    get getCodeText() {
        if (!this.geting)
            return '获取验证码';
        return this.countdownTimer;
    }
    get btnText() {
        return this.isHasRequire &&
            (this.learninEnv === 'app' || this.isOldNotAvailable)
            ? '打开APP体验'
            : '立即学习';
    }
    async sendSmsCode() {
        if (!this.phoneNumber) {
            this.$Toast('请输入手机号');
            return;
        }
        if (!/^1[3456789]\d{9}$/.test(this.phoneNumber)) {
            this.$Toast('手机号格式不正确');
            return;
        }
        if (this.geting)
            return;
        this.geting = true;
        this.$emit('sendSmsCode', this.phoneNumber);
        for (let count = 60; count > 0; count--) {
            this.countdownTimer = `重新获取 ${count}s`;
            await utils.sleep(1000);
        }
        this.geting = false;
    }
    async freeGetHandelr() {
        await this.$emit('addStatistics', 'click_freeGet');
        if (!this.phoneNumber || !this.smsCode) {
            this.$Toast('请输入必要信息');
            return;
        }
        await this.$emit('clickHandler', {
            type: 'freeGet',
            phoneNumber: this.phoneNumber,
            smsCode: this.smsCode,
        });
    }
    learnCourse() {
        if (this.isHasRequire &&
            !this.isOldNotAvailable &&
            this.learninEnv === 'h5') {
            this.$emit('learn_course');
        }
        else {
            this.$emit('clickHandler', {
                type: 'openApp',
            });
        }
    }
};
tslib_1.__decorate([
    Prop({ default: false })
], CourseCard.prototype, "isHasRequire", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], CourseCard.prototype, "isOldNotAvailable", void 0);
tslib_1.__decorate([
    Prop({ default: false })
], CourseCard.prototype, "isFirst", void 0);
tslib_1.__decorate([
    Prop()
], CourseCard.prototype, "learninEnv", void 0);
CourseCard = tslib_1.__decorate([
    Component
], CourseCard);
export default CourseCard;
